import styled          from 'styled-components';

import { cssFlexRow,
         themeColors } from 'src/providers/theme/shared';



type SwitchLookAndFeel = {
  width: number;
  height: number;
  bgWidth: number;
  bgHeight: number;
  ballSize: number;

  checkedBgColor: string;
  checkedBgOpacity: number;
  checkedBallColor: string;
  uncheckedBgColor: string;
  uncheckedBgOpacity: number;
  uncheckedBallColor: string;
  uncheckedBorderColor: string;
  uncheckedBorderWidth: number;
}

const switch_w40h24: SwitchLookAndFeel = {
  width: 40,
  height: 24,
  bgWidth: 34,
  bgHeight: 14,
  ballSize: 20,

  checkedBgColor: themeColors.AccentBlue2,
  checkedBgOpacity: 50,
  checkedBallColor: themeColors.AccentBlue2,
  uncheckedBgColor: themeColors.SecondaryGray4,
  uncheckedBgOpacity: 100,
  uncheckedBallColor: themeColors.PrimaryWhite,
  uncheckedBorderColor: themeColors.SecondaryGray3,
  uncheckedBorderWidth: 1,
}

const switch_w42h26: SwitchLookAndFeel = {
  width: 42,
  height: 26,
  bgWidth: 42,
  bgHeight: 26,
  ballSize: 16,
  
  checkedBgColor: themeColors.AccentBlue2,
  checkedBgOpacity: 100,
  checkedBallColor: themeColors.PrimaryWhite,
  uncheckedBgColor: themeColors.PrimaryWhite,
  uncheckedBgOpacity: 100,
  uncheckedBallColor: themeColors.AccentBlue2,
  uncheckedBorderColor: themeColors.SecondaryGray3,
  uncheckedBorderWidth: 1,
}

export type SwitchVariants = 'w40h24' | 'w42h26';

export const switch_variants: Map<SwitchVariants, SwitchLookAndFeel> = 
  new Map<SwitchVariants, SwitchLookAndFeel>([
    ['w40h24', switch_w40h24],
    ['w42h26', switch_w42h26],
  ]);

export const Container = styled.div<{
  lookAndFeel: SwitchLookAndFeel
}>`
  ${cssFlexRow};

  justify-content: center;
  align-items: center;

  width: ${(args) => args.lookAndFeel.width}px;
  height: ${(args) => args.lookAndFeel.height}px;
`

export const Checkbox = styled.div<{
  lookAndFeel: SwitchLookAndFeel
}>`
  ${cssFlexRow};

  width: ${(args) => args.lookAndFeel.bgWidth}px;
  height: ${(args) => args.lookAndFeel.bgHeight}px;

  > input {
    opacity: 0;
    width: 0;
    height: ${(args) => args.lookAndFeel.bgHeight}px;
  }

  > input + i {
    position: relative;
    width: ${(args) => args.lookAndFeel.bgWidth}px;
    height: ${(args) => args.lookAndFeel.bgHeight}px;
  }

  > input + i::before {
    position: absolute;
    content: '';
    left: 0;
    top: 0;
    width: ${(args) => args.lookAndFeel.bgWidth}px;
    height: ${(args) => args.lookAndFeel.bgHeight}px;
  
    background-color: ${(args) => args.lookAndFeel.uncheckedBgColor};
    opacity: ${(args) => args.lookAndFeel.uncheckedBgOpacity}%;
  
    border-radius: ${(args) => args.lookAndFeel.bgHeight * 1.25}px;
    transition: background-color 0.3s, opacity 0.3s;
    border: ${(args) => args.lookAndFeel.uncheckedBorderWidth}px solid ${(args) => args.lookAndFeel.uncheckedBorderColor};
    box-sizing: border-box;
  }

  > input + i::after {
    position: absolute;
    content: '';
    width: ${(args) => args.lookAndFeel.ballSize}px;
    height: ${(args) => args.lookAndFeel.ballSize}px;
    position: absolute;
    left: ${(args) => (args.lookAndFeel.bgHeight - args.lookAndFeel.ballSize) / 2}px;
    top: ${(args) => (args.lookAndFeel.bgHeight - args.lookAndFeel.ballSize) / 2}px;
  
    background-color: ${(args) => args.lookAndFeel.uncheckedBallColor};
    border-radius: 50%;
    opacity: 100%;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.237602), 0px 0px 1px rgba(0, 0, 0, 0.12);
    transition: background-color 0.3s, left 0.3s;
  }

  > input:checked + i::before {
    background-color: ${(args) => args.lookAndFeel.checkedBgColor};
    opacity: ${(args) => args.lookAndFeel.checkedBgOpacity}%;
    border: none;
  }

  > input:checked + i::after {
    background-color: ${(args) => args.lookAndFeel.checkedBallColor};
    left: ${(args) => args.lookAndFeel.bgWidth - args.lookAndFeel.ballSize + (args.lookAndFeel.ballSize - args.lookAndFeel.bgHeight) / 2}px;
  }
`;
